import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const SpendingIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <g id="Icon / Library">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5152 5.38885C6.02972 5.45476 5.57148 5.57899 5.14654 5.75724C5.48006 5.28304 5.9873 4.96216 6.55939 4.89877L15.6659 3.88984C16.6287 3.78317 17.5719 4.42836 17.8805 5.45445C17.7332 5.42362 17.583 5.3984 17.4302 5.37895C17.1512 5.33116 16.8762 5.32155 16.6252 5.32155H7.3749C7.08159 5.32155 6.79479 5.34361 6.5152 5.38885ZM20.7627 7.1884C20.4054 6.74676 19.9806 6.37643 19.5001 6.08551L19.4606 5.72849C19.2376 3.7158 17.5018 2.17725 15.5007 2.39896L6.39421 3.4079C4.50486 3.61722 3.18981 5.30582 3.23647 7.18773L3.21721 7.21168C2.41996 8.20941 1.99976 9.52221 1.99976 11.005C1.99976 11.4193 2.33554 11.755 2.74976 11.755C3.16397 11.755 3.49976 11.4193 3.49976 11.005C3.49976 9.80404 3.83808 8.83757 4.38905 8.14805C4.93609 7.46345 5.72678 7.00775 6.72513 6.87412C6.73246 6.87313 6.73978 6.87205 6.74708 6.87085C6.94502 6.83836 7.15405 6.82155 7.3749 6.82155H16.6252C16.8492 6.82155 17.0296 6.83118 17.1877 6.85929C17.2006 6.86159 17.2136 6.86355 17.2266 6.86517C18.2381 6.99062 19.0409 7.44504 19.5965 8.13185C20.1354 8.79792 20.4746 9.72448 20.4989 10.8722C20.4852 10.8718 20.4713 10.8716 20.4574 10.8716H17.5502C16.1142 10.8716 14.9501 12.0357 14.9501 13.4717C14.9501 14.9077 16.1142 16.0717 17.5502 16.0717H20.4574C20.4713 16.0717 20.4852 16.0716 20.4989 16.0712C20.4724 17.3316 20.0667 18.3246 19.4313 19.0023C18.7779 19.6993 17.8272 20.122 16.6252 20.122H12H9.68747C9.27326 20.122 8.93747 20.4578 8.93747 20.872C8.93747 21.2862 9.27326 21.622 9.68747 21.622H12H16.6252C18.1983 21.622 19.5602 21.058 20.5256 20.0283C21.4869 19.0029 22.0003 17.575 22.0003 15.9385V11.005C22.0003 9.51068 21.5722 8.18901 20.7627 7.1884ZM5.59266 20.4773C5.29977 20.7702 4.82489 20.7702 4.532 20.4773L2.21943 18.1647C1.92653 17.8719 1.92653 17.397 2.21943 17.1041C2.51232 16.8112 2.98719 16.8112 3.28009 17.1041L4.31233 18.1363L4.31233 13.9343C4.31233 13.5201 4.64812 13.1843 5.06233 13.1843C5.47654 13.1843 5.81233 13.5201 5.81233 13.9343L5.81233 18.1363L6.84457 17.1041C7.13747 16.8112 7.61234 16.8112 7.90523 17.1041C8.19813 17.397 8.19813 17.8719 7.90523 18.1647L5.59266 20.4773ZM16.4501 13.4717C16.4501 12.8641 16.9427 12.3716 17.5502 12.3716H20.4574C20.4811 12.3716 20.5003 12.3908 20.5003 12.4145V14.5289C20.5003 14.5525 20.4811 14.5717 20.4574 14.5717H17.5502C16.9427 14.5717 16.4501 14.0792 16.4501 13.4717Z"
          fill="#555555"
        />
      </g>
    </svg>
  );
};
